import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getMenuItemStatus, getMenuError } from '@store/reducers/menu/selectors';
import { createMenuItem } from '@store/actions/menu';
import Main from './Main';

const mapStateToProps = state => ({
  status: getMenuItemStatus(state),
  errors: getMenuError(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      createMenuItem,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
